import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const unitPriceSX: SxProps<Theme> = {
	color: 'grey.500',
	fontWeight: OpenSansFontWeights.semibold,
};

export const unitFreePriceSX: SxProps<Theme> = {
	color: 'success.main',
	fontWeight: OpenSansFontWeights.semibold,
};
